import { POST, GET } from '@/utils/request'
import Api from './url'

export const getViolationBill = async (params: object) => {
  return await GET({
    url: Api.getViolationBill,
    params,
    showError: false
  })
}
